import React from 'react';
import { Card, CardImg, CardBody, CardTitle, Button, Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Loading } from './LoadingComponent';

function RenderMenuItem({ dish }) {
    return (
        <Card>
            <Link to={`/keto/${dish._id}`} >
                <CardImg width="100%" src={dish.image} alt={dish.name} />
                <CardBody className="card-link-color">
                    <CardTitle>{dish.name} <Button outline>read more</Button></CardTitle>
                </CardBody>
            </Link>
        </Card>
    );
}

const Keto = (props) => {

    const menu = props.dishes.dishes.map((dish) => {
        return (
            <div key={dish._id} className="col-12 col-md-5 m-1">
                <RenderMenuItem dish={dish} />
            </div>
        );
    });

    if (props.dishes.isLoading) {
        return (
            <div className="container">
                <div className="row">
                    <Loading />
                </div>
            </div>
        );
    }
    else if (props.dishes.errMess) {
        return (
            <div className="container">
                <div className="row">
                    <h4>{props.dishes.errMess}</h4>
                </div>
            </div>
        );
    }
    else
        return (
            <div className="container">
                <div className="row">
                    <Breadcrumb>
                        <BreadcrumbItem><Link to='/home'>Home</Link></BreadcrumbItem>
                        <BreadcrumbItem active>Keto</BreadcrumbItem>
                    </Breadcrumb>
                    <div className="col-12">
                        <h3>Keto Menu</h3>
                        <hr />
                    </div>
                </div>
                <div className="row">
                    {menu}
                </div>
            </div>
        );
}

export default Keto;


// WEBPACK FOOTER //
// ./src/components/KetoComponent.js